module.exports = {"pickpack":{"titlePick":"Pick","titlePack":"Pack","pick":"Pick","pack":"Pack","toDelivery":"Delivery"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/pickpack.json
// module id = 567
// module chunks = 35